import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AppEnvironment } from '@env/app-environment';
import { environment } from '@env/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent implements OnInit {
  constructor(private oidcSecurityService: OidcSecurityService, private http: HttpClient) {}
  appConfigPath: string = '/assets/config/app.config.json';

  ngOnInit() {
    this.loadRuntimeDependencies();
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, userData, accessToken, idToken }) => {});
  }

  private loadRuntimeDependencies() {
    setTimeout(() => {
      if (environment.production == false) this.appConfigPath = '/assets/config/app.config.Dev.json';

      this.http.get<AppEnvironment>(window.location.origin + this.appConfigPath).subscribe(
        (config: AppEnvironment) => {
          this.overrideStaticConfigurations(config);
        },
        (error: any) => {
          this.configMissingErrorHandler.bind(this);
        }
      );
    }, 500);
  }
  private configMissingErrorHandler(error: Response | any) {
    console.warn('runtime configurations not found, using compile time configurations');
    console.log(environment);
    return Observable.create();
  }
  private overrideStaticConfigurations(configObject: AppEnvironment) {
    environment.clientId = configObject.clientId;
    environment.apiUrl = configObject.apiUrl;
    environment.authority = configObject.authority;
    environment.redirectUrl = configObject.redirectUrl;
    environment.apmEnabled = configObject.apmEnabled;
    environment.apmUrl = configObject.apiUrl;
    environment.name = configObject.name;
    console.log(environment);
  }

  login() {
    console.log('start login');
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    console.log('start refreshSession');
    this.oidcSecurityService.authorize();
  }

  logout() {
    console.log('start logoff');
    this.oidcSecurityService.logoff();
  }
}
